/**
 * Checks for the DICOM Part 10 preamble ("DICM" at byte offset 128).
 */
export function isDicomPart10ArrayBuffer(arrayBuffer: ArrayBuffer): boolean {
  if (arrayBuffer.byteLength <= 132) {
    return false;
  }

  const preamble = new Uint8Array(arrayBuffer, 128, 4);
  return (
    preamble[0] === 0x44 &&
    preamble[1] === 0x49 &&
    preamble[2] === 0x43 &&
    preamble[3] === 0x4d
  );
}

/**
 * Heuristic for raw DICOM datasets that omit the Part 10 header.
 */
export function isLikelyDicomDatasetArrayBuffer(arrayBuffer: ArrayBuffer): boolean {
  if (isDicomPart10ArrayBuffer(arrayBuffer)) {
    return true;
  }

  if (arrayBuffer.byteLength < 8) {
    return false;
  }

  const view = new DataView(arrayBuffer);
  const firstGroup = view.getUint16(0, true);

  // Common leading groups in DICOM datasets.
  return firstGroup === 0x0008 || firstGroup === 0x0002 || firstGroup === 0x0004;
}

/** @deprecated Use isDicomPart10ArrayBuffer or isLikelyDicomDatasetArrayBuffer */
export function isDicomArrayBuffer(arrayBuffer: ArrayBuffer): boolean {
  return isDicomPart10ArrayBuffer(arrayBuffer);
}
